import React from 'react';
import PropTypes from 'prop-types';

import Card from 'bundles/apex/card';

import 'bundles/backoffice/vouchers/editor/form/details_panel/styles.scss';

export default function DetailsCard({ children, tbodyRef, ...props }) {
  return (
    <Card {...props}>
      <table className="details-table">
        <tbody ref={tbodyRef}>
          {children}
        </tbody>
      </table>
    </Card>
  );
}

DetailsCard.propTypes = {
  children: PropTypes.node.isRequired,
  tbodyRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};
